import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils/index'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'

const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return data
}

const processFiuDataReq = (
  applicationId: string,
  status: string,
  comments: string,
  tokens: any,
  filterType: string,
) => {
  const request: JFSRequest<{}> = {
    apiPath: filterType === 'AADHAR_REDACTION' ? APIEndPoints.aadharRedactionProcess : getUrl(APIEndPoints.processFiu),
    method: 'POST',
    cache: false,
    body: {
      applicationId: applicationId,
      applicationStatus: status,
      comment: comments,
      ...(filterType?.length > 0 && { filterType: filterType }),
    },
    config: sitConfig(tokens),
    headers: getHeaders(),
  }

  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}

export { processFiuDataReq }
